const config = {
  appId: "wx771820531f2d9634", //问卷加加
  name: "问卷加加",
  mainTitle: "问卷加加-小程序问卷调研制作平台,考试评测,市场调研免费制作",
  title: "问卷加加",
  logo: "https://ossfastmake.mustke.com/qrCode/tupian/1755832594677.png",
  companyName: "哈尔滨快智科技有限公司",
  filing: "黑ICP备19003235号-83",
  logoTitle: require("@/assets/images/config/wjjj_title.svg"),
  loginLogo: require("@/assets/images/config/login_logo_jj.png"),
  miniProgramCode: require("@/assets/images/config/miniProgramCode1.jpg"),
  kefuCode: require("@/assets/images/config/kefuCode1.png"),
  bannerImage: require("@/assets/images/config/bannerImage1.png"),
  subscriptions: require("@/assets/images/config/subscriptions1.png"),
  // 添加favicon配置
  favicon: {
    // 默认favicon
    default: "https://ossfastmake.mustke.com/qrCode/tupian/1755832594677.png",
    // 可以根据需要添加更多favicon配置
    alternative:
      "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
  },
};

// const config = {
//   appId: "wx970228cfffbc37d2", //问卷管家
//   name: "问卷管家",
//   mainTitle: "问卷管家|问卷调研小程序制作平台,考试测评,考题调查快速发起",
//   title: "问卷管家",
//   logo: "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//   companyName: "哈尔滨优智科技有限公司",
//   filing: "黑ICP备13000410号-113",
//   logoTitle: require("@/assets/images/config/wjgj_title.svg"),
//   loginLogo: require("@/assets/images/config/login_logo_gj.png"),
//   miniProgramCode: require("@/assets/images/config/miniProgramCode2.jpg"),
//   kefuCode: require("@/assets/images/config/kefuCode2.png"),
//   bannerImage: require("@/assets/images/config/bannerImage2.png"),
//   subscriptions: require("@/assets/images/config/subscriptions2.jpg"),
//   // 添加favicon配置
//   favicon: {
//     // 默认favicon
//     default: "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//     // 可以根据需要添加更多favicon配置
//     alternative:
//       "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//   },
// };

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js